import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';

import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class FirstLoginPasswordGuard
  implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (
      !this.authService.isAuthenticated()
    ) {
      return this.router.createUrlTree(
        ['/login'],
        {
          queryParams: {
            returnUrl: state.url
          }
        }
      );
    }

    /*
     * Only users with temporary passwords
     * may open this page.
     */
    if (
      this.authService
        .isFirstLoginPasswordResetRequired()
    ) {
      return true;
    }

    /*
     * User already completed first-login password.
     */
    return this.router.createUrlTree([
      '/dashboard'
    ]);
  }
}